import React, { useState, useEffect } from 'react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 400);
  };

  const handleDecline = () => {
    setIsClosing(true);
    setTimeout(() => {
      setIsVisible(false);
      setIsClosing(false);
    }, 400);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className={`fixed bottom-0 left-0 right-0 bg-gray-900 text-white shadow-lg z-50 ${
      isClosing ? 'animate-slideDownToBottom' : 'animate-slideUpFromBottom'
    }`}>
      <div className="w-full px-4 py-4 sm:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4">
            <div className="flex-1 min-w-0">
              <p className="text-xs sm:text-sm lg:text-base leading-relaxed">
                We use cookies to enhance your experience on our website. By continuing to use this site, 
                you agree to our use of cookies for analytics, personalization, and advertising purposes.
                <a 
                  href="/privacy-policy" 
                  className="text-blue-400 hover:text-blue-300 underline ml-1 whitespace-nowrap"
                >
                  Learn more
                </a>
              </p>
            </div>
            <div className="flex gap-2 sm:gap-3 flex-shrink-0 w-full sm:w-auto">
              <button
                onClick={handleDecline}
                className="flex-1 sm:flex-none px-3 sm:px-4 py-2 text-xs sm:text-sm border border-gray-600 hover:bg-gray-800 rounded transition-colors whitespace-nowrap"
              >
                Decline
              </button>
              <button
                onClick={handleAccept}
                className="flex-1 sm:flex-none px-3 sm:px-4 py-2 text-xs sm:text-sm bg-[#4bcfe1] hover:bg-[#4bcfe1] rounded transition-colors whitespace-nowrap"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;